"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var confirm_popup_component_1 = require("../confirm-popup/confirm-popup.component");
var PopUpsService = /** @class */ (function () {
    function PopUpsService() {
        this._confirmPopup = confirm_popup_component_1.ConfirmPopup;
    }
    Object.defineProperty(PopUpsService.prototype, "confirmPopup", {
        get: function () {
            return this._confirmPopup;
        },
        set: function (value) {
            this._confirmPopup = value;
        },
        enumerable: true,
        configurable: true
    });
    return PopUpsService;
}());
exports.PopUpsService = PopUpsService;
//# sourceMappingURL=pop-ups.service.js.map